import React from 'react'
import useMuiCompontent from '../../../../Hooks/useMuiCompontent';
import { Modal } from 'react-bootstrap';
import { Errors } from '../../../../Component/Error';

const AddTestModal = ({ methods, data }) => {
    const { CustomButton } = useMuiCompontent()
    const {
        openModal,
    } = data

    const {
        handleOpenModal,
        handleClosedModal,
        newAddTestsRequested,
    } = methods
    return (
        <>
            <Modal show={openModal.tests} onHide={() => { handleClosedModal("tests"); handleOpenModal("add", openModal?.previoursData) }} centered>
                <Modal.Body>
                    <div className="text-center">
                        <h4 className="modal-title mb-3">Add Test</h4>
                    </div>
                    <div className="modal-body  cus-i">
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label mb-0">Test<span className='Star_Mark'>*</span></label>
                            <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                value={newAddTestsRequested?.values?.Tests}
                                onChange={(e) => newAddTestsRequested?.setFieldValue("Tests", e.target.value)}
                            />
                            <Errors formikfun={newAddTestsRequested} name={"Tests"} />
                        </div>
                    </div>
                    <div className="text-center mt-3">
                        <CustomButton className='me-2' variant="outlined" onClick={() => { handleClosedModal("tests"); handleOpenModal("add", openModal?.previoursData) }} >Cancel </CustomButton>
                        <CustomButton variant="contained" onClick={newAddTestsRequested.handleSubmit} >Save</CustomButton>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddTestModal
